// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/modal.ts

const Modal = {
  parts: [
    "overlay",
    "dialogContainer",
    "dialog",
    "header",
    "closeButton",
    "body",
    "footer",
  ],
  baseStyle: ({ colorMode }) => ({
    dialog: {
      overflow: "hidden"
    },
    body: {
      py: 8,
      bg: "bg.main",
    },
    header: {
      bg: "bg.main",
      borderBottomWidth: "1px",
      borderBottomColor: "border",
    },
    footer: {
      bg: "bg.high",
    },
    closeButton: {
    },
  }),
  sizes: {
    sm: {
      dialog: {

      },
    },
  },
}

export default Modal
